module.exports = __webpack_public_path__ + "img/details.aac22052.svg";